"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const actionNames = __importStar(require("./constants/actions"));
const ActiveRequests_1 = __importDefault(require("./ActiveRequests"));
const request_1 = __importDefault(require("./actions/request"));
const setup_1 = __importDefault(require("./actions/setup"));
const exchangeToken_1 = __importDefault(require("./actions/exchangeToken"));
const injectImpersoToken_1 = __importDefault(require("./actions/injectImpersoToken"));
const unlockPersistence_1 = __importDefault(require("./actions/unlockPersistence"));
const lockPersistence_1 = __importDefault(require("./actions/lockPersistence"));
const storeSession_1 = __importDefault(require("./actions/storeSession"));
const removePersistence_1 = __importDefault(require("./actions/removePersistence"));
const logout_1 = __importDefault(require("./actions/logout"));
const poll_1 = __importDefault(require("./actions/poll"));
const setupDiscovery_1 = __importDefault(require("./actions/setupDiscovery"));
const extractToken_1 = __importDefault(require("./actions/extractToken"));
const getServiceUrl_1 = __importDefault(require("./actions/getServiceUrl"));
const cancelRequestsByGroup_1 = __importDefault(require("./actions/cancelRequestsByGroup"));
const cancelRequestTimeouts_1 = __importDefault(require("./actions/cancelRequestTimeouts"));
const setState_1 = __importDefault(require("./actions/setState"));
const createMiddleware = (_a) => {
    var { auth, serviceCache } = _a, options = __rest(_a, ["auth", "serviceCache"]);
    const activeRequests = new ActiveRequests_1.default();
    const actions = {
        [actionNames.API_SETUP]: setup_1.default,
        [actionNames.API_REQUEST]: request_1.default,
        [actionNames.API_EXCHANGE_AUTH_TOKEN]: exchangeToken_1.default,
        [actionNames.API_LOGOUT]: logout_1.default,
        [actionNames.API_STORE_SESSION]: storeSession_1.default,
        [actionNames.API_INJECT_IMPERSO_TOKEN]: injectImpersoToken_1.default,
        [actionNames.API_UNLOCK_PERSISTENCE]: unlockPersistence_1.default,
        [actionNames.API_LOCK_PERSISTENCE]: lockPersistence_1.default,
        [actionNames.API_REMOVE_PERSISTENCE]: removePersistence_1.default,
        [actionNames.API_POLL]: poll_1.default,
        [actionNames.API_SETUP_DISCOVERY]: setupDiscovery_1.default,
        [actionNames.API_EXTRACT_TOKEN]: extractToken_1.default,
        [actionNames.API_GET_SERVICE_URL]: getServiceUrl_1.default,
        [actionNames.API_CANCEL_REQUESTS_BY_GROUP]: cancelRequestsByGroup_1.default,
        [actionNames.API_CANCEL_REQUEST_TIMEOUTS]: cancelRequestTimeouts_1.default,
        [actionNames.API_SET_STATE]: setState_1.default,
    };
    const state = {
        subscribed: false,
    };
    return (store) => (next) => (action) => {
        if (actions[action.type]) {
            const utils = {
                getState: store.getState,
                auth,
                activeRequests,
                next,
                serviceCache,
                dispatch: store.dispatch,
                options,
                state,
            };
            return actions[action.type](utils)(action);
        }
        return next(action);
    };
};
exports.default = createMiddleware;
